import script from "./nav.vue?vue&type=script&setup=true&lang=js"
export * from "./nav.vue?vue&type=script&setup=true&lang=js"

import "./nav.vue?vue&type=style&index=0&id=95389e12&lang=scss&scoped=true"

import exportComponent from "/Users/anxin/Documents/Vue/河南Vue网站/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95389e12"]])

export default __exports__